import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { Button } from "@volca/ui/components/ui/button";
import { cn } from "@volca/ui/lib/utils";
import type { AiScriptChatSelectionContext } from "@/payroll/ai-script/types";
import {
  formatSelectionContextChip,
  formatSelectionContextTitle,
} from "./selection-context";

interface SelectionContextChipProps {
  context: AiScriptChatSelectionContext;
  onDismiss?: () => void;
}

export const SelectionContextChip = ({
  context,
  onDismiss,
}: SelectionContextChipProps) => (
  <span
    className={cn(
      "inline-flex h-7 max-w-full items-center gap-1.5 rounded-full border border-line bg-surface pl-2.5 text-xs",
      { "pr-1": !!onDismiss, "pr-2.5": !onDismiss },
    )}
  >
    <span className="shrink-0 font-medium text-subtle">
      {formatSelectionContextTitle(context)}
    </span>
    <span
      className="truncate text-ink"
      title={formatSelectionContextChip(context)}
    >
      {formatSelectionContextChip(context)}
    </span>
    {onDismiss && (
      <Button
        variant="ghost"
        size="icon-xs"
        aria-label="Remove selection context"
        onClick={onDismiss}
        className="rounded-full text-subtle"
      >
        <XIcon />
      </Button>
    )}
  </span>
);
